import { useLocalization } from '@/shared/composables/localization'

export enum ErrorType {
  USER_NOT_IDENTIFIED = 'USER_NOT_IDENTIFIED',
  CHAT_FAILED = 'CHAT_FAILED',
  HISTORY_FAILED = 'HISTORY_FAILED',
  CONTACTS_AND_GROUPS_FAILED = 'CONTACTS_AND_GROUPS_FAILED',
  CONFIGURATION_FAILED = 'CONFIGURATION_FAILED',
  SELECTOR_FAILED = 'SELECTOR_FAILED',
  MESSAGING_FAILED = 'MESSAGING_FAILED',
}

export const getErrorDescription = (key: ErrorType) => {
  const { t } = useLocalization()

  const errors = { [ErrorType.USER_NOT_IDENTIFIED]: t('common.currentUserNotFound'),
    [ErrorType.CHAT_FAILED]: t('common.messageServiceError'),
    [ErrorType.HISTORY_FAILED]: t('common.historyNotLoaded'),
    [ErrorType.CONTACTS_AND_GROUPS_FAILED]: t('common.failedToGetContactsAndGroups'),
    [ErrorType.CONFIGURATION_FAILED]: t('common.failedToGetConfig'),
    [ErrorType.SELECTOR_FAILED]: t('common.noConnectionWithSelector'),
    [ErrorType.MESSAGING_FAILED]: t('common.messageExchangeServiceError'),
  } as const

  return errors[key]
}
